import { cn } from "@/lib/cn"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"
import { ComponentPropsWithRef } from "react"

export const buttonVariants = cva(
  "inline-flex items-center justify-center rounded-btn font-bold tracking-wide disabled:pointer-events-none disabled:opacity-40",
  {
    variants: {
      variant: {
        default:
          "border-btn border-btn-primary-border bg-btn-primary text-paragraph-m text-btn-primary-text disabled:border-btn-primary-disabled disabled:bg-btn-primary-disabled",
        secondary:
          "border-btn border-btn-secondary-border bg-btn-secondary text-paragraph-m  text-btn-secondary-text  disabled:border-btn-secondary-disabled disabled:bg-btn-secondary-disabled",
        outline:
          "border-px border-btn-outlined-border text-paragraph-m text-btn-outlined-text",
        rounded:
          "rounded-full border-btn-primary-border bg-btn-primary text-paragraph-m text-btn-primary-text disabled:border-btn-primary-disabled disabled:bg-btn-primary-disabled",
        roundedOutline:
          "bg-btn-outlined rounded-full border-px border-btn-outlined-border text-paragraph-m text-btn-outlined-text",
        ghost: "border-none bg-transparent",
      },
      size: {
        default: "h-9 px-3 py-[.375rem]",
        dialogSubmit:
          "min-w-[20.5rem] px-[1.9375rem] py-[0.5625rem] md:min-w-[unset]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export type ButtonProps = ComponentPropsWithRef<"button"> &
  VariantProps<typeof buttonVariants> & { asChild?: boolean }

export function Button({
  className,
  variant,
  size,
  ref,
  asChild = false,
  type = "button",
  ...props
}: ButtonProps) {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      type={type}
      {...props}
    />
  )
}
